import React from 'react'
import './index.scss'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const HistoryCompactWorkItemHeader = () => (
    <div className="history-compact-work-header">
        <div>Song Title</div>
        <div>Writers</div>
        <div>
            <span className="label-with-tooltip">
                <CustomToolTip
                    info={
                        <>
                            This reflects total shares you have submitted to The MLC. These submitted shares are subject
                            to review and approval by The MLC before being processed.
                        </>
                    }
                    inverse
                    type="?"
                />
                Your Total Submitted Shares
            </span>
        </div>
    </div>
)

export default HistoryCompactWorkItemHeader
